exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host { display: block; }\r\n.offboard-collection-heading { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; -webkit-box-align: baseline; -ms-flex-align: baseline; align-items: baseline; gap: 8px 16px; }\r\n.offboard-collection-heading h4 { -webkit-box-flex: 1; -ms-flex: 1 1 180px; flex: 1 1 180px; min-width: 0; margin: 0; overflow-wrap: break-word; }\r\n.offboard-collection-heading .btn { -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; min-height: 36px; }\r\n.offboard-collection-identity, .offboard-collection-message { margin: 4px 0 0; }\r\n.offboard-collection-form { margin-top: 12px; }\r\n.offboard-collection-form .form-group { margin-bottom: 8px; }\r\n.offboard-collection-form input[type=\"number\"] { max-width: 140px; }\r\n.offboard-collection-form textarea { min-height: 64px; }\r\n.offboard-collection-form .offboard-choice { display: block; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-collection.component.css
// module id = ../../../../../src/app/content-page/offboarding/offboarding-collection.component.css
// module chunks = main